enum Route {
  AdditionalAppForm = "/additionalAppForm",
  AdditionalAppFormDacError = "/additionalAppForm/dacFailed",
  Application = "/application",
  AuthenticationCodeRequestPage = "/authenticationCodeRequestPage",
  BasicAppForm = "/basicAppForm",
  Calculation = "/calculation",
  CheckoutSelect = "/checkoutSelect",
  SoftCreditApproved = "/softCreditApproved",
  SoftCreditRefused = "/softCreditRefused",
  Dac = "/dac",
  Data = "/data",
  DataProtection = "/data-protection",
  DocumentUpload = "/documentUpload",
  DocumentUploadSuccess = "/documentUploadSuccess",
  Error = "/error",
  Esign = "/acceptance-esign",
  EsignApproved = "/esign-approved",
  EsignFailed = "/ident-failed",
  EsignPending = "/ident-pending",
  EsignRefused = "/esign-refused",
  EsignSuccess = "/ident-succeeded",
  ExpiredSession = "/expired-session",
  FullApplicationForm = "/fullApplicationForm",
  Licenses = "/licenses",
  Maintenance = "/maintenance",
  Prefill = "/prefill",
  Rejection = "/rejection",
  Summary = "/summary",
  VehicleUnavailable = "/vehicleUnavailable",
  TermsAndConditionsPage = "/termsandconditions",
  BoniLanding = "/boni-landing",
  BoniRefused = "/boni-refused",
  BoniSuccessDealer = "/boni-success-dealer",
  BoniSuccessUCC = "/boni-success-ucc",
}

export default Route;
export { Route };
